import { render, staticRenderFns } from "./PartnersTcRecordList.vue?vue&type=template&id=492b7eaa&"
import script from "./PartnersTcRecordList.vue?vue&type=script&lang=js&"
export * from "./PartnersTcRecordList.vue?vue&type=script&lang=js&"
import style0 from "./PartnersTcRecordList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports